import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { RejectFiscalDocumentValidationSchema } from "../schemas/rejectFiscalDocument.schema";

interface UseRejectFiscalDocument {
  id: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

const useBillingEventRejectFiscalDocument = ({ id, onSuccess, onError }: UseRejectFiscalDocument) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['rejectFiscalDocument', id],
    mutationFn: async (form: RejectFiscalDocumentValidationSchema) => {
      const payload = {
        eventable_attributes: {
          fiscal_document_attributes: {
            rejection_reason: form.rejection_reason,
          },
        },
      };

      return await privateAxios.post(`/billing/events/${id}/reject_fiscal_document`, payload);
    },
    onSuccess,
    onError,
  });
};

export default useBillingEventRejectFiscalDocument;
